const toArray = (value) => (Array.isArray(value) ? value : []);

export const unique = (items = []) => Array.from(new Set(items));

export const normalizeTextList = (value) => {
  if (Array.isArray(value)) {
    return value
      .map(String)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (typeof value === "string" && value.trim()) {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};

export const coerceNumberOrUndef = (value) => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "number") return Number.isFinite(value) ? value : undefined;

  const normalized = String(value).trim().replace(",", ".");
  if (!normalized) return undefined;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const coerceDateOrUndef = (value) => {
  if (!value) return undefined;

  const normalized = String(value).trim();
  return normalized ? normalized : undefined;
};

export const isProfileEffectivelyEmpty = (profile) => {
  const data = profile || {};

  const hasAnyValue =
    Boolean(data.displayName && String(data.displayName).trim()) ||
    Boolean(data.gender && String(data.gender).trim()) ||
    Boolean(data.ageRange && String(data.ageRange).trim()) ||
    Boolean(data.height ?? "") ||
    Boolean(data.startWeight ?? "") ||
    Boolean(data.startWeightDate && String(data.startWeightDate).trim()) ||
    Boolean(data.goalWeight ?? "") ||
    Boolean(data.goalDate && String(data.goalDate).trim()) ||
    Boolean(data.diagnosis && String(data.diagnosis).trim()) ||
    Boolean(
      (Array.isArray(data.healthIssues) && data.healthIssues.length) ||
        (data.comorbidities && String(data.comorbidities).trim())
    ) ||
    Boolean(data.otherMeds && String(data.otherMeds).trim()) ||
    Boolean((Array.isArray(data.objectives) && data.objectives.length) || data.objective);

  return !hasAnyValue;
};

export const normalizeProfile = (profile) => {
  const issues =
    profile?.healthIssues && Array.isArray(profile.healthIssues)
      ? normalizeTextList(profile.healthIssues)
      : normalizeTextList(profile?.comorbidities);

  return {
    displayName: profile?.displayName || "",
    gender: profile?.gender || "",
    ageRange: profile?.ageRange || "",
    height: profile?.height ?? "",
    startWeight: profile?.startWeight ?? "",
    startWeightDate: profile?.startWeightDate || "",
    goalWeight: profile?.goalWeight ?? "",
    goalDate: profile?.goalDate || "",
    diagnosis: profile?.diagnosis || "",
    healthIssues: issues.slice(0, 5),
    comorbidities: profile?.comorbidities || (issues.length ? issues.join(", ") : ""),
    otherMeds: profile?.otherMeds || "",
    objectives: toArray(profile?.objectives),
  };
};

export const buildProfilePayload = (profile) => {
  const cleanedHealthIssues = unique(normalizeTextList(profile?.healthIssues)).slice(0, 5);

  return {
    displayName: profile?.displayName || undefined,
    gender: profile?.gender || undefined,
    ageRange: profile?.ageRange || undefined,
    height: coerceNumberOrUndef(profile?.height),
    startWeight: coerceNumberOrUndef(profile?.startWeight),
    startWeightDate: coerceDateOrUndef(profile?.startWeightDate),
    goalWeight: coerceNumberOrUndef(profile?.goalWeight),
    goalDate: coerceDateOrUndef(profile?.goalDate),
    diagnosis: profile?.diagnosis || undefined,
    healthIssues: cleanedHealthIssues,
    comorbidities: cleanedHealthIssues.length
      ? cleanedHealthIssues.join(", ")
      : profile?.comorbidities || undefined,
    otherMeds: profile?.otherMeds || undefined,
    objectives: Array.isArray(profile?.objectives) ? profile.objectives : [],
  };
};